

export const getRestApiSort = (sorter) => sorter?.field !== undefined ? (sorter.field + ',' + (sorter.order === 'descend' ? 'desc' : 'asc')) : undefined;
